export default import.meta.ROLLDOWN_FILE_URL_T5iIHYSYe26skCMLnk6HyA